import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: stretch;
  height: 100%;
`
export const ActionsBlock = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  border-top: 1px solid var(--color-sw-10);
  padding: 16px 24px;

  @media screen and ${breakpoint.s} {
    flex-direction: column;
    align-items: stretch;
  }
`
export const Main = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex: 1;
  align-items: stretch;
  flex-direction: column;
  padding: 24px;

  @media screen and ${breakpoint.s} {
    padding: 16px;
  }
`
export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 678px;
  gap: 16px;
`
